import React from 'react'

const Mentorpage = () => {
  return (
    <div>Mentorpage</div>
  )
}

export default Mentorpage